import React from 'react'

import classnames from 'classnames'
import classNames from 'classnames'

import Container from '~/components/atoms/Container/Container'
import DynamicSlider from '~/components/atoms/DynamicSlider'
import { SliderThemes } from '~/components/atoms/Slider/sliderThemes'

import type { PartnerCardProps } from '../PartnerCard/PartnerCard'
import PartnerCard from '../PartnerCard/PartnerCard'

import styles from './FeaturedPartners.module.css'

interface FeaturedPartnersProps {
  partners: PartnerCardProps[]
  theme?: 'light' | 'dark'
  useDivider?: boolean
  hideTitle?: boolean
}

const FeaturedPartners: React.FC<FeaturedPartnersProps> = ({
  partners,
  theme = 'dark',
  useDivider = false,
  hideTitle = false,
}) => {
  partners.sort((a, b) => {
    if (a.type === 'sponsored') {
      return -1
    }
    if (b.type === 'sponsored') {
      return 1
    }
    return 0
  })
  return (
    <div className={classNames(styles.base, styles[`${theme}BaseTheme`])}>
      {useDivider && (
        <Container>
          <div className={styles.top}></div>
        </Container>
      )}
      <div style={{ overflow: 'hidden' }}>
        <div className={styles.wrap}>
          <Container cssClass={classnames(styles.sliderContainer)}>
            <DynamicSlider
              title="Featured Partners"
              slidesPerView={1.4}
              slidesPerViewMed={2.4}
              slidesPerViewLrg={partners.length <= 3 ? partners.length : 3.4}
              overflowVisible={true}
              hideTitle={hideTitle}
              hideArrows={false}
              hideArrowsMobile={true}
              theme={SliderThemes.light}
              useScrollbar
              spacer={true}
              extendRight={true}
              wrapperClass={styles.sliderWrapperClass}
              customControls={styles.sliderControls}
            >
              {partners &&
                partners.map((partner, index) => (
                  <PartnerCard
                    key={index}
                    {...partner}
                    portrait={true}
                    theme={theme}
                  />
                ))}
            </DynamicSlider>
          </Container>
        </div>
      </div>
    </div>
  )
}

export default FeaturedPartners
